import axios from "axios";

let config = require("../configuration.json");

axios.defaults.withCredentials = true;

const apiClient = axios.create({
  baseURL: config.serverUrl,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('session-expired'));
    }

    return Promise.reject(error);
  }
);

export default apiClient;
